import React, { useRef, useState} from "react";
import {
    Card,
    CardBody,
    CardTitle,
    Col,
    Form,
    FormGroup,
    Input,
    Label,
    Row
} from "reactstrap";
import {ErrorMessage, useForm} from "react-hook-form";
import {connect, useSelector} from "react-redux";
import * as Yup from "yup";



// components
import {  GenericTableButton } from "../../../components/buttons/buttonsActions";
import { LogHistoryModal } from "../../../components/logHistory/logHistoryModal";

// labels
import {
    INTERNATIONAL,
    REQUIRED
} from "../../../components/i18n/i18n";
import {TT_CLOSE, TT_HISTORY, TT_SAVE} from "../../../components/i18n/toolTips";
import {getStateByPath} from "../../../redux/selectors";
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";
import {roleService} from "../../../jwt/_services";
import {GenericButton} from "../../../components/buttons/customButtons";
import Separator from "../../../components/Separator";
import {setFilter, setForm, setItem, setTableParams} from "../../../redux/actions/generics/IndexedActions";
import Switch from "react-bootstrap-switch";
import AddonLangs from "../../configuration/addon/_langs";
import UserRoleSection from "../user/UserRoleSection";
import RoleUserSection from "./RoleUserSection";
import RolePermissionSection from "./RolePermissionSection";

// actions

// components
// services & providers

const RoleForm = props => {
    const componentState = useSelector(state => getStateByPath(state, props.path));
    const { path } = componentState;
    const { editMode, domainObject } = componentState?.data;

    // Banderas
    const [isAdmin, setIsAdmin] = useState( domainObject?.isAdmin !== undefined ? domainObject?.isAdmin : false);

    const [showHistoryModal, setShowHistoryModal] = useState(true);
    const modalHistoryRef = useRef(null);

    const showHistory = () => {
        setShowHistoryModal(true);
        modalHistoryRef.current.showModal(domainObject);
    }

    const validationSchema = Yup.object().shape({
        authority: Yup.string().required(REQUIRED)
    });

    const {register, handleSubmit, reset, errors} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: domainObject?.id,
            authority: domainObject?.authority
        }
    });


    const onSubmit = (data, _) => {
        let dataRequest = {
            ...data,
            isAdmin: isAdmin
        };

        // console.log(dataRequest);
        // return;

        if (editMode) {
            let id = domainObject.id;
            dataRequest.id = id

            genericIndexedActions.update(path, roleService, id, dataRequest)
        } else {
            genericIndexedActions.save(path, roleService, dataRequest)
        }

        closeForm()
    };

    const closeForm = () => {
        reset();
        props.setItem(path, null);
        props.setForm(path, false, false, false);
        props.onClose();
    }

    return (<>
            <Card className={'card-modal-medium'}>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <CardTitle className="bg-light border-bottom p-3 mb-0">
                        <i className="far fa-edit mr-2"/>
                        <>
                            <h2 className={'card-modal-title'}> {(domainObject?.authority || '') }</h2>
                            <br/>
                        </>
                        <div className={'top-right'}>
                            <GenericButton
                                style={'table'}
                                icon={'fa-save'}
                                toolTip={TT_SAVE}
                                permission={'add'}
                                type={'submit'}
                            />
                            {
                                editMode && <>
                                    <GenericTableButton
                                        toolTip={TT_HISTORY}
                                        icon={'fa-clock'}
                                        permission={'search'}
                                        onClick={showHistory}
                                    />
                                </>
                            }
                            <Separator/>
                            <GenericButton
                                style={'danger-secondary'}
                                toolTip={TT_CLOSE}
                                icon={'fa-times'}
                                permission={'search'}
                                onClick={closeForm}
                            />
                        </div>
                    </CardTitle>
                    <CardBody>
                        <Row>
                            <Col md="8">
                                <FormGroup>
                                    <Label>{'Nombre del rol'}</Label>
                                    <Input type="name" name="authority"
                                           placeholder="Nombre del rol"
                                           innerRef={register}
                                           style={{textTransform: 'uppercase'}}
                                           className={(errors.authority ? ' is-invalid' : '')}
                                    />
                                    <ErrorMessage errors={errors} name="authority" component="div"
                                                  className="invalid-feedback"/>
                                </FormGroup>
                            </Col>
                            <Col md="4">
                                <FormGroup>
                                    <Label>{'Es rol administrativo'}</Label>
                                    <br/>
                                    <Switch animate={true}
                                            offText={"No"}
                                            onText={"Si"}
                                            innerRef={register}
                                            onChange={_ => setIsAdmin(!isAdmin)}
                                            value={isAdmin}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        {
                            editMode &&
                            <div className={'form-container'}>
                                <div className={''}>
                                    <RoleUserSection path={path}/>
                                </div>
                            </div>
                        }
                        {
                            editMode &&
                            <div className={'form-container'}>
                                <div className={''}>
                                    <h2>{'Permisos'}</h2>
                                </div>
                                <div className={''}>
                                    <RolePermissionSection path={path}/>
                                </div>
                            </div>
                        }
                    </CardBody>
                </Form>
            </Card>
            {
            showHistoryModal && <LogHistoryModal
                    ref={modalHistoryRef}
                    item={domainObject}
                />
            }
        </>
    )
}


const mapStateToProps = _ => ({})

const mapActionsToProps = ({
    setItem,
    setForm,
    setTableParams,
    setFilter,
})

export default connect(mapStateToProps, mapActionsToProps)(RoleForm)